import React, { useState, useEffect } from 'react';
import { Collapse } from 'react-bootstrap';
import clinicbookingService from '../../../../../services/clinicbooking.service';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import Loading from '../../../../common/Loading';
function AddBookingType() {
    const [apptType, setApptType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [showAddForm, setShowAddForm] = useState(false);
    const [editApptId, setEditApptId] = useState(null);
    const { clinicId } = useParams();

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        setValue,
        getValues,
    } = useForm();

    useEffect(() => {
        getAllApptType(true);
    }, []);

    const getAllApptType = (showLoader = false) => {
        if (showLoader) {
            setIsLoading(true);
        }
        clinicbookingService
            .getAllApptType(clinicId)
            .then((res) => {
                setApptType(res.data);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                if (showLoader) {
                    setIsLoading(false);
                }
            });
    };

    const toggleAddForm = () => {
        setShowAddForm(!showAddForm);
        if (showAddForm) {
            reset();
        }
    };

    const handleDelete = (bookingtype) => {
        setIsDeleting(true);
        clinicbookingService
            .deleteBookingType(bookingtype.clinicId, bookingtype.id)
            .then(() => {
                getAllApptType();
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setIsDeleting(false);
            });
    };

    const onSubmitEdit = (data) => {
        setIsSubmitting(true);

        // FIXED: Include clinicId in the edit data
        const editData = {
            ...data,
            id: editApptId,
            clinicId: clinicId // Add clinicId to the data
        };

        clinicbookingService
            .addUpdateBookingType(clinicId, editData)
            .then(() => {
                getAllApptType();
                setEditApptId(null);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const onSubmitNew = (data) => {
        setIsSubmitting(true);
        // FIXED: Corrected the property name from clinicID to clinicId
        const newData = { ...data, clinicId: clinicId };

        clinicbookingService
            .addUpdateBookingType(clinicId, newData)
            .then(() => {
                reset();
                getAllApptType();
                setShowAddForm(false);
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    // Helper function to handle time slot increment/decrement
    const adjustTimeSlot = (amount, isEditMode = false) => {
        const fieldName = isEditMode ? "timeSlot" : "timeSlot";
        const currentValue = parseInt(getValues(fieldName) || "0");
        const newValue = Math.max(1, Math.min(480, currentValue + amount));
        setValue(fieldName, newValue, { shouldValidate: true });
    };

    return (
        <>
            <div className="clinic-booking-toolbar">
                <div>
                    Total: <strong>{apptType.length}</strong> type{apptType.length !== 1 ? 's' : ''}
                </div>
                <button
                    type="button"
                    className={`btn btn-sm ${showAddForm ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                    onClick={toggleAddForm}
                >
                    <i className={`bi ${showAddForm ? 'bi-x-lg' : 'bi-plus-lg'} me-1`}></i>
                    {showAddForm ? 'Cancel' : 'Add Type'}
                </button>
            </div>

            <Collapse in={showAddForm}>
                <div className="mb-3">
                    <div className="notifications-panel">
                        <div className="notifications-panel__header">
                            <i className="bi bi-plus-circle"></i>
                            Add New Appointment Type
                        </div>
                        <div className="notifications-panel__body">
                            <form onSubmit={handleSubmit(onSubmitNew)}>
                                <div className="row g-3">
                                    <div className="col-md-4">
                                        <label htmlFor="apptType" className="notifications-form-label">
                                            Appointment Type <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control form-control-sm ${errors.apptType ? 'is-invalid' : ''}`}
                                            id="apptType"
                                            {...register('apptType', { required: 'Type is required' })}
                                            placeholder="e.g., General Checkup"
                                        />
                                        {errors.apptType && <div className="invalid-feedback">{errors.apptType.message}</div>}
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="timeSlot" className="notifications-form-label">
                                            Duration (minutes) <span className="text-danger">*</span>
                                        </label>
                                        <div className="input-group input-group-sm" style={{ maxWidth: '220px' }}>
                                            <button className="btn btn-outline-secondary" type="button" onClick={() => adjustTimeSlot(-5)}>
                                                <i className="bi bi-dash"></i>
                                            </button>
                                            <input
                                                type="number"
                                                className={`form-control text-center ${errors.timeSlot ? 'is-invalid' : ''}`}
                                                id="timeSlot"
                                                {...register('timeSlot', {
                                                    required: 'Duration is required',
                                                    min: { value: 1, message: 'Duration must be at least 1 minute' },
                                                    max: { value: 480, message: 'Duration cannot exceed 8 hours' },
                                                })}
                                                placeholder="30"
                                                min="1"
                                                max="480"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                            <button className="btn btn-outline-secondary" type="button" onClick={() => adjustTimeSlot(5)}>
                                                <i className="bi bi-plus"></i>
                                            </button>
                                        </div>
                                        {errors.timeSlot && <div className="invalid-feedback d-block">{errors.timeSlot.message}</div>}
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="isActive" className="notifications-form-label">
                                            Status <span className="text-danger">*</span>
                                        </label>
                                        <select
                                            className={`form-select form-select-sm ${errors.isActive ? 'is-invalid' : ''}`}
                                            id="isActive"
                                            {...register('isActive', { required: 'Status is required' })}
                                        >
                                            <option value="true">Active</option>
                                            <option value="false">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="clinic-booking-form-actions">
                                    <button className="btn btn-success btn-sm" type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                Adding…
                                            </>
                                        ) : (
                                            <>
                                                <i className="bi bi-plus-circle me-1"></i>
                                                Add Type
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Collapse>

            {isLoading ? (
                <Loading />
            ) : apptType.length > 0 ? (
                <div className="table-responsive">
                    <table className="table table-bordered table-hover align-middle mb-0 process-queue-table clinic-booking-table">
                        <thead>
                            <tr>
                                <th>
                                    <i className="bi bi-calendar2-event"></i> Appointment Type
                                </th>
                                <th>
                                    <i className="bi bi-stopwatch"></i> Duration
                                </th>
                                <th>
                                    <i className="bi bi-toggle-on"></i> Status
                                </th>
                                <th className="text-end">
                                    <i className="bi bi-gear"></i> Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {apptType.map((appt) => (
                                <tr key={appt.id} className={`clinic-booking-row ${editApptId === appt.id ? 'table-active' : ''}`}>
                                    {editApptId === appt.id ? (
                                        <>
                                            <td>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-sm ${errors.apptType ? 'is-invalid' : ''}`}
                                                    {...register('apptType', { required: 'Type is required' })}
                                                    placeholder="e.g., General Checkup"
                                                />
                                                {errors.apptType && <div className="invalid-feedback">{errors.apptType.message}</div>}
                                            </td>
                                            <td>
                                                <div className="input-group input-group-sm" style={{ maxWidth: '180px' }}>
                                                    <button className="btn btn-outline-secondary" type="button" onClick={() => adjustTimeSlot(-5, true)}>
                                                        <i className="bi bi-dash"></i>
                                                    </button>
                                                    <input
                                                        type="number"
                                                        className={`form-control text-center ${errors.timeSlot ? 'is-invalid' : ''}`}
                                                        {...register('timeSlot', {
                                                            required: 'Duration is required',
                                                            min: { value: 1, message: 'Duration must be at least 1 minute' },
                                                            max: { value: 480, message: 'Duration cannot exceed 8 hours' },
                                                        })}
                                                        min="1"
                                                        max="480"
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                    <button className="btn btn-outline-secondary" type="button" onClick={() => adjustTimeSlot(5, true)}>
                                                        <i className="bi bi-plus"></i>
                                                    </button>
                                                </div>
                                                {errors.timeSlot && <div className="invalid-feedback d-block">{errors.timeSlot.message}</div>}
                                            </td>
                                            <td>
                                                <select className={`form-select form-select-sm ${errors.isActive ? 'is-invalid' : ''}`} {...register('isActive', { required: 'Status is required' })}>
                                                    <option value="true">Active</option>
                                                    <option value="false">Inactive</option>
                                                </select>
                                            </td>
                                            <td className="text-end">
                                                <div className="d-flex justify-content-end gap-1">
                                                    <button className="btn btn-success btn-sm" onClick={handleSubmit(onSubmitEdit)} disabled={isSubmitting} title="Save">
                                                        {isSubmitting ? <span className="spinner-border spinner-border-sm" role="status"></span> : <i className="bi bi-check-lg"></i>}
                                                    </button>
                                                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setEditApptId(null)} title="Cancel">
                                                        <i className="bi bi-x-lg"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            <td>
                                                <span className="clinic-booking-name">{appt.apptType}</span>
                                            </td>
                                            <td>
                                                <span className="clinic-booking-duration-badge">
                                                    <i className="bi bi-stopwatch"></i>
                                                    {appt.timeSlot} min
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`clinic-booking-status-badge ${appt.isActive === true ? 'clinic-booking-status-badge--active' : 'clinic-booking-status-badge--inactive'}`}>
                                                    {appt.isActive === true ? 'Active' : 'Inactive'}
                                                </span>
                                            </td>
                                            <td className="text-end">
                                                <div className="d-flex justify-content-end gap-1">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => {
                                                            setEditApptId(appt.id);
                                                            setValue('apptType', appt.apptType);
                                                            setValue('timeSlot', appt.timeSlot);
                                                            setValue('isActive', appt.isActive.toString());
                                                        }}
                                                        title="Edit"
                                                    >
                                                        <i className="bi bi-pencil"></i>
                                                    </button>
                                                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => handleDelete(appt)} disabled={isDeleting} title="Delete">
                                                        {isDeleting ? <span className="spinner-border spinner-border-sm" role="status"></span> : <i className="bi bi-trash"></i>}
                                                    </button>
                                                </div>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="clinic-booking-empty">
                    <i className="bi bi-calendar2-x"></i>
                    No appointment types configured.
                    <div className="mt-3">
                        <button type="button" className="btn btn-outline-primary btn-sm" onClick={toggleAddForm}>
                            <i className="bi bi-plus-lg me-1"></i>
                            Add First Type
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}

export default AddBookingType;